// These values should be maintained independently from, but respective to,
// the css breakpoints defined in ./scss/_vars.scss
const breakpoints = {
  mobileWidth: 600,
};

export default breakpoints;
